import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import SearchForm from 'app/commons/components/SearchForm';
import { withGlobalData } from 'app/utils/withGlobalData';
import { buildParams } from 'app/utils/pagination';
import Title from 'app/components/layouts/Title';
import { formatTime } from 'app/utils/dateUtils';
import Image from 'app/components/layouts/Image';
import { useTranslation } from 'next-i18next';
import * as listenApi from 'app/requests/listens';
import { useState, useEffect } from 'react';
import { setNewParams } from 'app/utils/ga';
import { useRouter } from 'next/router';
import { Music } from 'types/music';
import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import env from '.env.json';

const MusicBar = dynamic(() => import('app/components/music/MusicBar'), { ssr: false })

interface MusicPlayer {
  name: string,
  singer: string,
  cover: string,
  musicSrc: string,
  duration: number,
  id: string,
  canDownload: boolean,
}

export default function Index({ musics }) {
  const router = useRouter()
  const { t } = useTranslation();
  const [indexMusic, setIndexMusic] = useState(0);
  const [newMusic, setNewMusic] = useState([]);
  const defaultParam = {
    keyword: router.query.keyword || ''
  };
  const [params, setParams] = useState(defaultParam);
  const [isChange, setIsChange] = useState(false);

  useEffect(() => {
    const audioLists = (musics || []).map((music: Music) => {
      let thumb = music.thumbnailM;
      if (music._id) thumb = `${env.URL_API_FILE}/${thumb}`

      let audioUrl = music.audioUrl;
      if (music._id) audioUrl = `${env.URL_API_FILE}/${audioUrl}`;

      return {
        name: music.title,
        singer: music.artistsNames,
        cover: thumb,
        musicSrc: audioUrl,
        duration: music.duration,
        id: music._id,
        canDownload: !!!music._id
      }
    });

    setNewMusic(audioLists);
  }, [musics])

  useEffect(() => {
    if (isChange) {
      const url = `/music${buildParams(params)}`
      setIndexMusic(0);
      router.push(url, url)
    }
    setIsChange(true);
  }, [params])

  useEffect(() => {
    const musicIsActive = document.querySelector(".active-box") as HTMLElement;
    const top = musicIsActive?.offsetTop - 200;
    if (top > 0) {
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, [indexMusic])

  const setDataParams = (value: string | number, name: string, page: number | null = null) => {
    setNewParams(setParams, params, value, name, page);
  }

  const listMusic = () => {
    const lists = (newMusic || []).map((music: MusicPlayer, index: number) => {
      return (
        <div className={`mb-3 wrap-box-content ${index === indexMusic ? 'active-box' : ''}`} key={music.id}>
          <div onClick={() => setIndexMusic(index)} className="d-flex ml-2">
            <Image
              src={index === indexMusic ? '/images/commons/gif/music.gif' : music.cover}
              alt={music.name}
              width={50}
              height={50}
              className="image-listen mr-3 my-auto"
            />
            <div className="overflow-hidden">
              <div className="wrap-box-title text-left">{music.name}</div>
              <small className="float-left">{music.singer}</small>
            </div>
            <div className='time ml-auto text-info font-weight-bold' style={{ marginTop: 14 }}>
              {formatTime(music.duration)}
            </div>
          </div>
        </div>
      )
    })
    return lists;
  }

  return (
    <section className="box-card-area list-test">
      <NextSeo
        title={t('music.title')}
        description={t('music.music_description')}
        additionalMetaTags={[{
          name: 'keywords',
          content: 'luyện nghe tiếng anh, luyện nghe tiếng anh qua bài hát, bài hát tiếng anh, listen to English music, học tiếng anh qua bài hát, bài hát tiếng anh'
        }]}
      />
      <div className="container-md">
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title='music.title' />
              <div className='mt-3 mx-auto position-relative col-md-6'>
                <SearchForm setDataParams={setDataParams} />
              </div>
              {musics?.length > 0 &&
                <div>
                  <div className="mt-4">
                    {listMusic()}
                  </div>
                </div>
              }
              {!musics?.length &&
                <div className='text-danger text-center mt-3 text-size-xl'>
                  {t('commons.result_notfound')}
                </div>
              }
            </div>
          </div>
          <RightContent />
        </div>
        <MusicBar
          musics={newMusic}
          indexMusic={indexMusic}
          setIndexMusic={setIndexMusic}
          setNewMusic={setNewMusic}
        />
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query }) => {
  try {
    const [translations, musics] = await Promise.all([
      serverSideTranslations(locale, ['common']),
      listenApi.getMusic({
        ...query,
        direction: 'asc',
        from: 'home_page',
      }),
    ]);

    return {
      props: {
        ...translations,
        musics: musics || null,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
});
